interface ServingRuleErrorBody {
  error?: unknown;
  message?: unknown;
  title?: unknown;
  detail?: unknown;
}

function readDescription(detail: unknown): string | undefined {
  if (typeof detail === 'string') return detail || undefined;
  if (typeof detail !== 'object' || detail === null) return undefined;

  const { description } = detail as { description?: unknown };
  return typeof description === 'string' && description
    ? description
    : undefined;
}

export function extractServingRuleError(
  errorData: unknown,
  fallback: string
): string {
  if (typeof errorData !== 'object' || errorData === null) return fallback;

  const body = errorData as ServingRuleErrorBody;

  const nested =
    typeof body.error === 'object' && body.error !== null
      ? (body.error as ServingRuleErrorBody)
      : undefined;

  const nestedDescription = readDescription(nested?.detail);
  if (nestedDescription) return nestedDescription;
  if (typeof nested?.title === 'string' && nested.title) return nested.title;

  if (typeof body.message === 'string' && body.message) return body.message;

  const description = readDescription(body.detail);
  if (description) return description;
  if (typeof body.title === 'string' && body.title) return body.title;

  return fallback;
}
